import React from 'react';
import { useTranslation } from 'react-i18next';
import { AiFillCheckCircle, AiFillCloseCircle } from "react-icons/ai";
import Button from '../../../components/UI/Buttons/Button/Button';
import styles from '../SubscriptionDowngrade.module.css';

const PlanCard = ({ plan, loading }) => {
  const { t } = useTranslation();
  
  // If the plan is hidden, don't render anything
  if (plan.hidden) {
    return null;
  }
  
  // Function to format feature name with its value if available
  const formatFeatureText = (feature) => {
    const baseText = t(`subscription.features.${feature.name}`);
    
    if (feature.value) {
      // For features with numerical values like "X Applications Per Job"
      return baseText.replace('{value}', feature.value);
    }
    
    return baseText;
  };
  
  return (
    <div className={`${styles.planCard} ${plan.isActive ? styles.activePlan : ''}`}>
      <p className={styles.planName}>{plan.name} {t('subscription.plan')}</p>
      {plan.isActive && <div className={styles.activeBadge}>{t('subscription.current_plan')}</div>}
      <div className={styles.planPrice}>{plan.price}</div>

      <ul className={styles.featuresList}>
        {plan.features.map((feature, index) => (
          <li key={index} className={`${styles.featureItem} ${feature.available ? styles.available : styles.unavailable}`}>
            {feature.available ? <AiFillCheckCircle className={styles.checkIcon} /> : <AiFillCloseCircle className={styles.timesIcon} />}
            {formatFeatureText(feature)}
          </li>
        ))}
      </ul>

      {plan.isActive ? (
        <Button
          className={styles.activeButton}
          disabled={true}
        >
          {t('subscription.active')}
        </Button>
      ) : plan.hideButton ? (
        // Don't display any button when hideButton is true
        <div className={styles.emptyButtonSpace}></div>
      ) : (
        <button
          onClick={plan.buttonAction}
          className={styles.downgradeButton}
          disabled={loading}
        >
          {loading ? t('common.processing') : t(plan.buttonText)}
        </button>
      )}
    </div>
  );
};

export default PlanCard; 